"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfanityOptions = void 0;
class ProfanityOptions {
    constructor(options = {}) {
        var _a, _b, _c, _d, _e;
        this.wholeWord = (_a = options.wholeWord) !== null && _a !== void 0 ? _a : true;
        this.grawlix = (_b = options.grawlix) !== null && _b !== void 0 ? _b : "@#$%&!";
        this.grawlixChar = (_c = options.grawlixChar) !== null && _c !== void 0 ? _c : "*";
        this.languages = (_d = options.languages) !== null && _d !== void 0 ? _d : ["en"];
        this.unicodeWordBoundaries = (_e = options.unicodeWordBoundaries) !== null && _e !== void 0 ? _e : false;
    }
}
exports.ProfanityOptions = ProfanityOptions;
//# sourceMappingURL=profanity-options.js.map